export default __webpack_public_path__ + "3e613150d9a02004d88637e2d1231ef0.png";